import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import config from "../../../utils/config";
import { setUser } from "../../../store/action/auth";
import AuthService from "../../../services/auth/Auth";
import HttpService from "../../../services/http_service/HttpService";
import Http from "../../../services/http/Http";
import Input from "../../../components/input/Input";
import VerifyCode from "../../../components/input/VerifyCode";
import { Success, Warning } from "../../../components/button";
import {
  Container,
  ContainerItem,
  Row,
  Col,
  Logo,
  ItemContainer,
  RulesTime,
  ItemLink,
  Item,
  ContainerAnimation,
} from "./style";

var timer = false;

class Login extends Component {
  constructor(props) {
    super(props);
    this.timer = 120;

    this.state = {
      username: "",
      verification_code: "",
      timer: this.timer,
      verifyCode: false,
      isLoadingSendData: false,
    };

    this.loginBtnRef = createRef();
    this.usernameInputRef = createRef();
  }

  componentDidMount = () => {
    this.usernameInputRef.current.focus();
  };

  login = (e) => {
    if (e) e.preventDefault();

    if (this.state.isLoadingSendData === false) {
      this.setState({ isLoadingSendData: true, timer: this.timer });

      HttpService()
        .post("mobile/send", {
          mobile: this.state.username,
        })
        .then((response) => {
          this.setState({ verifyCode: true });

          timer = setInterval(() => {
            if (this.state.timer > 0) {
              this.setState({ timer: this.state.timer - 1 });
            } else {
              this.setState({ verifyCode: false });

              clearInterval(timer);
            }
          }, 1000);
          Http(response?.status, response?.data?.message, this.props);
        })
        .catch((error) => {
          Http(
            error?.response?.status,
            error?.response?.data?.message,
            this.props
          );
        })
        .finally(() => {
          this.setState({ isLoadingSendData: false });
        });
    }
  };

  loginVerify = (e) => {
    if (e) e.preventDefault();

    if (this.state.isLoadingSendData === false) {
      this.setState({ isLoadingSendData: true });

      HttpService()
        .post("mobile/verify", {
          mobile: this.state.username,
          verification_code: this.state.verification_code,
        })
        .then((response) => {
          var user = {
            data: response.data.user,
            token: response.data.token,
            address: response.data.address,
          };

          AuthService.setUser(user, this.props.setUser);

          this.setState({ verifyCode: false, editable: true });

          clearInterval(timer);

          Http(response?.status, response?.data?.message, this.props);

          this.props.history.goBack();
        })
        .catch((error) => {
          Http(
            error?.response?.status,
            error?.response?.data?.message,
            this.props
          );
        })
        .finally(() => {
          this.setState({ isLoadingSendData: false });
        });
    }
  };

  sendAgainVerifyCode = () => {
    this.setState({ verifyCode: false, username: "" });

    clearInterval(timer);
  };

  setVerifyCode = (stateName, value) => {
    this.setState({ [stateName]: value }, () => {
      this.loginBtnRef.current.click();
    });
  };

  handleChange = (stateName, value) => {
    this.setState({
      [stateName]: value,
    });
  };

  render() {
    const { theme } = this.props;

    return (
      <>
        <Container theme={theme} ver>
          <ContainerItem className="text-center">
            {!this.state.verifyCode ? (
              <form className="w-100" onSubmit={this.login}>
                <Row className="row no-gutters mb-5 pb-5">
                  <Col className="col-11 col-sm-6 col-md-11 mx-auto">
                    <Logo
                      src={config.logoTwo}
                      className="text-center d-flex mx-auto"
                      height="200"
                    />
                    <ItemContainer className="mb-3 mr-2 d-block text-center">
                      <Item>
                        شماره همراه خود را برای دریافت کدفعال سازی وارد کنید.
                      </Item>
                    </ItemContainer>
                    <Input
                      refrence={this.usernameInputRef}
                      name="username"
                      value={this.state.username}
                      onChange={this.handleChange}
                      placeHolder="شماره تماس را وارد کنید"
                      className="mb-3"
                      autocomplete="off"
                      disabled={this.state.verifyCode}
                      maxLength="11"
                      type="tel"
                    />
                    <ItemContainer className="mb-3 mr-2 d-block text-center">
                      <Item>با ورود به {config.title}،</Item>
                      <Link to="/faq">
                        <ItemLink className="mr-1 ml-1">شرایط استفاده</ItemLink>
                      </Link>
                      <Item>از آن را پذیرفته اید.</Item>
                    </ItemContainer>
                    <Warning
                      refrence={this.loginBtnRef}
                      title={this.state.verifyCode ? "ورود" : "ارسال کد"}
                      className="d-block mb-3"
                      isLoading={this.state.isLoadingSendData}
                      sizeSpinner={20}
                      onClick={
                        this.state.verifyCode ? this.loginVerify : this.login
                      }
                    />
                  </Col>
                </Row>
              </form>
            ) : (
              <form className="w-100" onSubmit={this.loginVerify}>
                <Row className="row no-gutters mb-5 pb-5 mt-3">
                  <Col className="col-11 col-sm-6 col-md-11 mx-auto">
                    <ContainerAnimation>
                      <ItemContainer className="mb-1 mr-2 d-block text-center">
                        <Item className="f-14">{this.state.username}</Item>
                      </ItemContainer>
                      <ItemContainer className="mb-3 mr-2 d-block text-center">
                        <Item>کد فعالسازی ارسال شده را وارد کنید</Item>
                      </ItemContainer>
                      <VerifyCode
                        name="verification_code"
                        onChange={this.setVerifyCode}
                      />
                      <ItemContainer className="mb-3 mr-2 d-block text-center">
                        <RulesTime className="ml-1">
                          {this.state.timer}
                        </RulesTime>
                        <Item>ثانیه دیگر تا امکان ارسال مجدد کد فعال سازی</Item>
                      </ItemContainer>
                    </ContainerAnimation>

                    <ItemContainer className="mb-3 mr-2 d-block text-center">
                      <Item>با ورود به {config.title}،</Item>
                      <Link to="/faq">
                        <ItemLink className="mr-1 ml-1">شرایط استفاده</ItemLink>
                      </Link>
                      <Item>از آن را پذیرفته اید.</Item>
                    </ItemContainer>
                    <Warning
                      refrence={this.loginBtnRef}
                      title={this.state.verifyCode ? "ورود" : "ارسال کد"}
                      className="d-block mb-3"
                      isLoading={this.state.isLoadingSendData}
                      sizeSpinner={20}
                      onClick={
                        this.state.verifyCode ? this.loginVerify : this.login
                      }
                    />
                    <ContainerAnimation>
                      <Success
                        className="d-block mb-3"
                        title="تغییر شماره تماس"
                        onClick={this.sendAgainVerifyCode}
                      />
                    </ContainerAnimation>
                  </Col>
                </Row>
              </form>
            )}
          </ContainerItem>
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, { setUser })(Login);
